import { Component, OnInit } from "@angular/core";
import { ExamsService } from "../exams.service";
import { LoginService } from "../login.service";

export interface AutoTextSnippet {
  SnippetID?: number;
  Content: string;
}

export interface AutoTextList {
  AutoTextListID: number;
  GID: number;
  Title: string;
  snippets: AutoTextSnippet[];
  assignedClinicTemplateIds: any[];
}

@Component({
    selector: "app-clinic-autotext",
    templateUrl: "./clinic-autotext.component.html",
    styleUrls: ["./clinic-autotext.component.scss"],
    standalone: false
})
export class ClinicAutotextComponent implements OnInit {
  lists: AutoTextList[] = [];
  clinicTemplates: any[] = [];
  title = "";
  snippets: AutoTextSnippet[] = [{ Content: "" }];
  selectedTemplateIds = new Set<any>();
  editingId: number | null = null;
  loading = false;
  showDeleteConfirm = false;
  listToDelete: AutoTextList = null;

  constructor(public es: ExamsService, public ls: LoginService) {}

  ngOnInit() {
    this.ls.loginMissing();
    this.load();
    try {
      this.es.getClinicTemplates().subscribe(
        (data: any) => { this.clinicTemplates = data || []; },
        (err) => { console.log(err); }
      );
    } catch (e) {
      console.log(e);
    }
  }

  load() {
    try {
      this.es.getAutoTextLists().subscribe(
        (data: any) => { this.lists = data || []; },
        (err) => { console.log(err); }
      );
    } catch (e) {
      console.log(e);
    }
  }

  toggleTemplate(id: any) {
    if (this.selectedTemplateIds.has(id)) this.selectedTemplateIds.delete(id);
    else this.selectedTemplateIds.add(id);
  }
  isTemplateSelected(id: any): boolean {
    return this.selectedTemplateIds.has(id);
  }

  addSnippetRow() {
    this.snippets.push({ Content: "" });
  }
  removeSnippetRow(i: number) {
    this.snippets.splice(i, 1);
    if (!this.snippets.length) this.addSnippetRow();
  }

  resetForm() {
    this.editingId = null;
    this.title = "";
    this.snippets = [{ Content: "" }];
    this.selectedTemplateIds = new Set<any>();
  }

  save() {
    if (!this.title || this.loading) return;
    const body = {
      Title: this.title,
      snippets: this.snippets.filter((s) => s.Content),
      assignedClinicTemplateIds: [...this.selectedTemplateIds],
    };
    this.loading = true;
    try {
      const obs = this.editingId
        ? this.es.updateAutoTextList(this.editingId, body)
        : this.es.createAutoTextList(body);
      obs.subscribe(
        (data: any) => { this.lists = data || []; this.resetForm(); this.loading = false; },
        (err) => { console.log(err); this.loading = false; }
      );
    } catch (e) {
      console.log(e);
      this.loading = false;
    }
  }

  edit(l: AutoTextList) {
    this.editingId = l.AutoTextListID;
    this.title = l.Title;
    this.snippets = (l.snippets && l.snippets.length) ? l.snippets.map((s) => ({ ...s })) : [{ Content: "" }];
    this.selectedTemplateIds = new Set<any>(l.assignedClinicTemplateIds || []);
  }

  confirmDelete(l: AutoTextList) {
    this.listToDelete = l;
    this.showDeleteConfirm = true;
  }
  cancelDelete() {
    this.listToDelete = null;
    this.showDeleteConfirm = false;
  }
  doDelete() {
    if (!this.listToDelete || this.loading) return;
    const id = this.listToDelete.AutoTextListID;
    this.loading = true;
    try {
      this.es.deleteAutoTextList(id).subscribe(
        (data: any) => {
          this.lists = data || [];
          this.showDeleteConfirm = false;
          this.listToDelete = null;
          this.loading = false;
          if (this.editingId === id) this.resetForm();
        },
        (err) => { console.log(err); this.loading = false; }
      );
    } catch (e) {
      console.log(e);
      this.loading = false;
    }
  }

  templateLabel(id: any): string {
    const t = this.clinicTemplates.find((x) => x.ClinicTemplateID == id);
    return t ? t.Title : ("Template " + id);
  }
}
